function fetchNews() {
  $('#hasPagination').remove();
  var url = window.location.origin + '/news/results/' + window.dre.count + '/' + window.dre.offset + '/' + window.dre.category;
  window.dre.offset += window.dre.count;
  $.get(url, 
    function(data) {
      $('.news-list-items').append(data);
      if (!$('#hasPagination').length) {
        $('#news-load-more').hide();
      } else {
        $('#news-load-more').show();
      }
    }
  );  
};


$().ready(function() {

	$('.menu-expand a').on('click', function(e){
		$('.nav-bar nav').slideToggle(250);
		e.preventDefault();
	})

	$('.step h3 a').on('click', function(e){
		$(this).closest('.step').find('.step-detail').slideToggle(200);
		e.preventDefault();
	});

  $('.news-category-nav button').on('click', function(e) {
    $('.news-category-nav li').removeClass('active');
    $(this).closest('li').addClass('active');
    $('.news-list-items').html('');
    window.dre.category = $(this).data('catid');
    window.dre.offset = 0;
    fetchNews();
  });

  $('#news-load-more').off('click').on('click', function(e) {
    fetchNews();
  });

});

jQuery(function($){
  var $form            = $('#ajax-form');
  var $generalErrors    = $('.general_errors');

  $form.submit(function(e){
    $('.error_message, #response').hide().html('');
    $generalErrors.hide().html('');
    $.post(
      $form.attr('action'),
      $form.serialize(),
      function(data){
        if (data.success == false) {
          $.each(data.errors, function(i, item){
            var $errorHolder = $('[name="' + i + '"]').parent().find('.error_message');
            var error = ($.isArray(item) ? item.join('<br/>') : item);
            error = error.replace('Required field missing input', 'Please complete this field');
            if ($errorHolder.length > 0) {
              $errorHolder.append('<p>' + error + '</p>').show();
            } else {
              $generalErrors.append('<p>' + error + '</p>').show();
            }
          });
        }
        else if (data.success) {
          $form.slideUp();
          $('#response').html('Thank you, we will be in touch.').show();
        }
      }
    );
    e.preventDefault();
    return false;
  });
});